import {
  CancelableQueryViewArgs,
  query,
  Query,
  QueryHandlerFunction,
  QueryHandlerFunctionArgs,
} from "@lookiero/messaging";
import { QuestionProjection } from "@lookiero/sty-psp-quiz-style-profile-common-ui";

const VIEW_STYLE_PROFILE_DEFINITION_BY_CUSTOMER_ID = "view_style_profile_definition_by_customer_id";

interface ViewStyleProfileDefinitionByCustomerIdPayload {
  readonly customerId: string;
}

interface ViewStyleProfileDefinitionByCustomerId
  extends Query<typeof VIEW_STYLE_PROFILE_DEFINITION_BY_CUSTOMER_ID>, ViewStyleProfileDefinitionByCustomerIdPayload {}

interface ViewStyleProfileDefinitionByCustomerIdFunction {
  (payload: ViewStyleProfileDefinitionByCustomerIdPayload): ViewStyleProfileDefinitionByCustomerId;
}

const viewStyleProfileDefinitionByCustomerId: ViewStyleProfileDefinitionByCustomerIdFunction = (payload) => ({
  ...query({ name: VIEW_STYLE_PROFILE_DEFINITION_BY_CUSTOMER_ID }),
  ...payload,
});

type ViewStyleProfileDefinitionByCustomerIdResult = QuestionProjection[] | null;

interface StyleProfileDefinitionByCustomerIdViewArgs extends CancelableQueryViewArgs {
  readonly customerId: string;
}

interface StyleProfileDefinitionByCustomerIdView {
  (args: StyleProfileDefinitionByCustomerIdViewArgs): Promise<ViewStyleProfileDefinitionByCustomerIdResult>;
}

interface ViewStyleProfileDefinitionByCustomerIdHandlerFunctionArgs extends QueryHandlerFunctionArgs {
  readonly view: StyleProfileDefinitionByCustomerIdView;
}

const viewStyleProfileDefinitionByCustomerIdHandler: QueryHandlerFunction<
  ViewStyleProfileDefinitionByCustomerId,
  ViewStyleProfileDefinitionByCustomerIdResult,
  ViewStyleProfileDefinitionByCustomerIdHandlerFunctionArgs
> =
  ({ view, signal }) =>
  async ({ customerId }) =>
    view({ customerId, signal });

export type { StyleProfileDefinitionByCustomerIdView, ViewStyleProfileDefinitionByCustomerIdResult };
export {
  VIEW_STYLE_PROFILE_DEFINITION_BY_CUSTOMER_ID,
  viewStyleProfileDefinitionByCustomerId,
  viewStyleProfileDefinitionByCustomerIdHandler,
};
